<template lang="html" src="./sea-path.html"></template>
<style lang="scss" scoped src="./sea-path.scss"></style>

<script>
export default {
  name: "SeaPath"
};
</script>
